module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-05-bbb4f50d68f5077bffad38690962dd85.jpg";